<!--<app-counselling-individuals-report></app-counselling-individuals-report>-->
<!--<app-counselling-group-session></app-counselling-group-session>-->
<!--<app-counselling-assessment-report></app-counselling-assessment-report>-->
<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">

  <mat-tab label="Education Individual Report">

    <app-education-individual-reporting></app-education-individual-reporting>
  </mat-tab>

  <mat-tab label="Education Group Report"><app-education-group-reporting></app-education-group-reporting>
  </mat-tab>
</mat-tab-group>
